// extracted by mini-css-extract-plugin
module.exports = {"image_wrapper":"how-it-works_image_wrapper__3Lua2","image":"how-it-works_image__1R7dT"};